const routes = [
  {
    path: '/m/yuren/inputstudentinfo',
    name: 'mInputStudentInfo',
    component: () => import('@/views/yurenManagement/mobile/InputStudentInfo'),
  },
  {
    path: '/m/learningHub',
    name: 'mLearningHub',
    component: () => import('@/views/learningHub/mobile/index.mobile.vue'),
    meta: {
      title: 'WPS 365 学习园地',
    },
  },
  {
    path: '/m/learningHub/search',
    name: 'mLearningHubSearch',
    component: () => import('@/views/learningHub/mobile/Search.vue'),
    meta: {
      title: '学习园地',
    },
  },
  {
    path: '/m/learningHub/more',
    name: 'mLearningHubMore',
    component: () => import('@/views/learningHub/mobile/index.mobile.more.vue'),
    meta: {
      title: 'WPS 365 学习园地',
    },
  },
  {
    path: '/m/schoolOpensBenefits',
    name: 'mSchoolOpensBenefits',
    component: () => import('@/views/schoolOpensBenefits/index.mobile.vue'),
    meta: {
      title: '乐享特权卡，积分赢豪礼',
    },
  },
  {
    path: '/m/ssoLogin',
    name: 'mSsoLogin',
    component: () => import('@/views/ssoLogin/mobile/index.mobile.vue'),
    meta: {
      title: '乐享特权卡，积分赢豪礼',
    },
  },
  {
    path: '/m/fission',
    name: 'mFission',
    component: () => import('@/views/fissionConfigurable/Fission.mobile.vue'),
    meta: {
      title: 'WPS 365教育版 | 锦鲤活动',
    },
  },
  // 登录后引导导入文档和关联权益
  {
    path: '/m/relatedAccount',
    name: 'mRelatedAccount',
    component: () => import('@/views/relatedAccount/RelatedAccount.m.vue'),
    meta: {
      title: '',
    },
  },
  // 题库C转B
  {
    path: '/m/question-privilege',
    name: 'mQuestionPrivilege',
    component: () => import('@/views/questionPrivilege/QuestionPrivilege.m.vue'),
    meta: {
      title: 'WPS 计算机备考福利大放送！',
    },
  },
]

export default routes